import { RoomTypeCategory } from "../models/roomTypeCategory.model";
import { ListItem } from "../models/ListItem";
import GenericService from "./genericService";
import { httpService } from './httpService';

class CategoryService extends GenericService<RoomTypeCategory, ListItem> {
    constructor() {
        super("/api/RoomTypeCategories");
    }
    async getByRoomTypeId(id: number | string): Promise<RoomTypeCategory[]> {
              return await httpService.get<RoomTypeCategory[]>(`/api/RoomTypeCategories/GetByRoomTypeId/${id}`, undefined, {
                  unwrap: true,
                  normalize: true,
                  toast: false,
              });
          }
}
export const categoryService = new CategoryService();